/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2NHnM%7Bpadding-top%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxbp0Oa%7Bpadding-right%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Qp0Oa%7Bpadding-left%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWS40j%7Bpadding-bottom%3Avar(--ds-space-500%2C40px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fwxA5DIqT%7Btext-align%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSzUZr%7Bwhite-space%3Anormal%7D");
import { cx } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Flex, Text } from '@atlaskit/primitives/compiled';
const styles = {
  containerV2: "_0Of8r2NHnM _1Znuxbp0Oa _2Zuz6Qp0Oa _1wydGWS40j _2fwxA5DIqT",
  whiteSpaceNormal: "_1ANEUSzUZr"
};
type EmptyStateProps = {
  header: string;
  testId?: string;
  description?: React.ReactNode;
  renderImage?: () => React.ReactNode;
  /** Only rendered if fg `platform-linking-visual-refresh-link-picker` is enabled */
  action?: React.ReactNode;
};
export const EmptyState = ({
  testId,
  header,
  description,
  action,
  renderImage
}: EmptyStateProps): JSX.Element => {
  return <Flex xcss={cx(styles.containerV2, fg('platform_link_picker_fix_error_state_text_overflow') && styles.whiteSpaceNormal)} testId={testId} direction="column" alignItems="center" gap="space.200">
			{renderImage?.()}

			<Heading size="small" as="h2">
				{header}
			</Heading>

			{description && <Text as="p" color="color.text">
					{description}
				</Text>}

			{action && action}
		</Flex>;
};